export function initApp() {
  console.clear();
  console.log(
    "%c WELCOME TO MOXEY! ",
    "color : #3cd17f; border : solid;font-size: 30px;font-weight: bold; padding: 5%; margin: 5%"
  );
}
